import { Store, select } from '@ngrx/store';
import { Observable, combineLatest } from 'rxjs';

import { getCurrentLocale } from 'ish-core/store/core/configuration';
import { whenTruthy } from 'ish-core/utils/operators';

import { getDotCmsHostId, getDotcmsSelectedLanguageId } from '../dotcms-configuration/dotcms-configuration.selectors';

export function getDotCmsCommonRequestParams<T>(store: Store) {
  return (source$: Observable<T>) =>
    combineLatest([
      source$,
      store.pipe(select(getDotCmsHostId), whenTruthy()),
      store.pipe(select(getDotcmsSelectedLanguageId), whenTruthy()),
    ]);
}

export function getDotCmsHostIdAndIcmCurrentLocale<T>(store: Store) {
  return (source$: Observable<T>) =>
    combineLatest([
      source$,
      store.pipe(select(getDotCmsHostId), whenTruthy()),
      store.pipe(select(getCurrentLocale), whenTruthy()),
    ]);
}
